module.exports = __webpack_public_path__ + "static/scale-model-of-leila's-hair-museum-in-independence-missouri-14244b40e801cd819b4459abef272493.png";